export const INPUT_BASE_TYPES = {
  NUMBER: 'number',
  STRING: 'string',
  BOOLEAN: 'boolean',
  ARRAY: 'array'
};

export const INPUT_ELEMENT_TYPES = {
  RADIO_GROUP: 'radioGroup',
  SLIDER: 'slider',
  RADIO_BUTTON: 'radioButton',
  SWITCH: 'switch'
};

export const LLM_RESPONSE_FORMAT = {
  JSON: {
    value: 'json',
    label: 'JSON Object'
  },
  TEXT: {
    value: 'text',
    label: 'Text'
  }
};
